<template>
    <div class="">
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <div class="p-4">
            <div v-for="(contact, index) in contacts" :key="contact" class="w-full">
                <div>
                    <contact-details-form
                        :contact-data="contact"
                        :application-reference="applicationReference"
                        :item-index="index"
                        :contact-detail-types-list="contactDetailTypesList"
                        :countries-of-domicile-list="countriesOfDomicileList"
                        @delete="removeOne"
                    />
                </div>
            </div>
        </div>

        <div v-if="previewAddressText" class="w-full flex text-left p-4 text-center m-auto">
            <p class="m-auto"><b>Communication Address:</b> {{ previewAddressText }}</p>
        </div>

        <div v-if="previewAddressError" class="w-full flex text-left p-4 text-center m-auto">
            <p class="m-auto text-danger">{{ previewAddressError }}</p>
        </div>

        <div class="w-1/2 flex text-left text-center m-auto">
            <div class="flex" v-if="addressCount < 2">
                <button class="btn-green mb-8" @click="newAddress">Add an<span v-if="addressCount > 0">other</span> address</button>
            </div>

            <div class="flex ml-4" v-if="addressCount > 0">
                <button class="btn-green mb-8" @click="previewAddress">Preview Communication Address</button>
            </div>
        </div>
    </div>
</template>

<script>

import ContactDetailsForm from '@/views/Application/Details/ContactDetailsForm'

export default {
    components: {
        ContactDetailsForm,
    },
    props: {
        contactData: Object,
        applicationReference: String,
        contactDetailTypesList: Object,
        countriesOfDomicileList: Object,
        countryOfDomicileId: String,
    },
    data() {
        return {
            contacts: Object,
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            addAddress: false,
            previewAddressText: '',
            previewAddressError: '',
        }
    },
    computed: {
        addressCount() {
            return this.contacts.length + ((this.addAddress === true)? 1: 0)
        },
    },
    mounted() {
        this.contacts = this.contactData

        if (this.contacts.length === 0)
        {
            this.newAddress()
        }
    },
    methods: {
        removeOne(index) {
            this.contacts.splice(index, 1)
        },
        newAddress() {
            this.contacts.push({
                reference: null,
                address_line1: null,
                address_line2: null,
                address_line3: null,
                city_town: null,
                post_zip_code: null,
                county_state: null,
                country_id: null,
                phone_number: null,
                alt_number: null,
                fax_number: null,
                type_id: null,
            })
        },
        previewAddress() {
            let address = [this.contacts[0].address_line1, this.contacts[0].city_town, this.contacts[0].county_state, this.contacts[0].post_zip_code]
            if (this.contacts[0].address_line2 !== undefined && this.contacts[0].address_line2 !== null) {
                address.slice(1, 0, this.contacts[0].address_line2)
            }

            if (this.contacts[0].address_line3 !== undefined && this.contacts[0].address_line3 !== null) {
                address.slice(2, 0, this.contacts[0].address_line3)
            }

            let countyOfDomicile = this.countriesOfDomicileList.find(c => c.reference === this.countryOfDomicileId)
            if (countyOfDomicile) {
                address.push(countyOfDomicile.name)
                this.previewAddressText = address.join(', ')
                this.previewAddressError = ''
            }
            else {
                this.previewAddressText = ''
                this.previewAddressError = 'You must enter country of Domicile before you can preview communication address.'
            }

        }
    },
}
</script>